// Renommez ce fichier 'config.js' une fois votre objet de configuration 
// Firebase inclut ci-dessous :
const firebaseConfig = {
    apiKey: "AIzaSyAaDzMud_ixCRZEjJhp6I06Wkzmez8gUa0",
    authDomain: "yannick-langlois-react.firebaseapp.com",
    projectId: "yannick-langlois-react",
    storageBucket: "yannick-langlois-react.appspot.com",
    messagingSenderId: "1067586726466",
    appId: "1:1067586726466:web:9b3c19d4041733f1de5bdb",
    measurementId: "G-2R4DB6RHR5"
};

export default firebaseConfig;